(() => {
  const initialize = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const strings = JSON.parse(root.querySelector('[data-myggp-strings]').textContent);
    const status = root.querySelector('[data-status]');
    const say = (message) => { if (status) status.textContent = message; };
    const previewParams = new URLSearchParams(location.search);
    const previewThemeId = previewParams.get('preview_theme_id') || (root.dataset.domainLive !== 'true' ? root.dataset.previewThemeId : '');
    root.querySelectorAll('[data-project-link]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
        if (previewParams.has(key)) url.searchParams.set(key, previewParams.get(key));
      });
      link.href = url.pathname + url.search + url.hash;
    });
    const stored = (key) => { try { return localStorage.getItem(key) === 'true'; } catch { return false; } };
    const save = (key, value) => {
      try { localStorage.setItem(key, String(value)); return localStorage.getItem(key) === String(value); }
      catch { return false; }
    };
    const favoriteKey = 'myggpspace.favorite.v1';
    const mutedKey = 'myggpspace.updates_muted.v1';
    let favorite = stored(favoriteKey);
    let muted = stored(mutedKey);
    const favoriteButton = root.querySelector('[data-favorite]');
    const updateFavorite = () => {
      if (!favoriteButton) return;
      favoriteButton.setAttribute('aria-pressed', String(favorite));
      favoriteButton.querySelector('[data-favorite-label]').textContent = favorite ? strings.removeFavorite : strings.favorite;
    };
    const updateMuted = () => {
      root.querySelectorAll('[data-updates]').forEach((element) => { element.hidden = muted; });
      root.querySelectorAll('[data-muted-banner]').forEach((element) => { element.hidden = !muted; });
      const preferencesStatus = root.querySelector('[data-preferences-status]');
      if (preferencesStatus) preferencesStatus.textContent = muted ? strings.muted : strings.restored;
    };
    updateFavorite();
    updateMuted();
    if (favorite) say(strings.saved);
    favoriteButton?.addEventListener('click', () => {
      const next = !favorite;
      if (!save(favoriteKey, next)) { say(strings.storageError); return; }
      favorite = next;
      updateFavorite();
      say(favorite ? strings.saved : strings.removed);
    });
    const setMuted = (value) => {
      if (!save(mutedKey, value)) {
        const message = root.querySelector('[data-preferences-status]');
        if (message) message.textContent = strings.storageError;
        say(strings.storageError);
        return;
      }
      muted = value;
      updateMuted();
      say(muted ? strings.muted : strings.restored);
    };
    root.querySelector('[data-mute]')?.addEventListener('click', () => setMuted(true));
    root.querySelectorAll('[data-restore]').forEach((button) => button.addEventListener('click', () => setMuted(false)));
    const openDialog = (name) => {
      const dialog = root.querySelector(`[data-dialog="${name}"]`);
      if (!dialog) return;
      dialog.showModal();
      document.documentElement.classList.add('myggp-no-scroll');
    };
    root.querySelectorAll('[data-open-dialog]').forEach((button) => {
      button.addEventListener('click', () => openDialog(button.dataset.openDialog));
    });
    root.querySelectorAll('dialog').forEach((dialog) => {
      dialog.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => document.documentElement.classList.remove('myggp-no-scroll'));
    });
    const newsletterReturn = root.querySelector('.myggp-newsletter input[name="return_to"]');
    if (newsletterReturn) {
      const destination = new URL(newsletterReturn.value, location.origin);
      if (previewThemeId) destination.searchParams.set('preview_theme_id', previewThemeId);
      ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
        if (previewParams.has(key)) destination.searchParams.set(key, previewParams.get(key));
      });
      newsletterReturn.value = destination.pathname + destination.search + destination.hash;
    }
    let shareUrl = root.dataset.shareUrl;
    if (previewThemeId) {
      const previewUrl = new URL(root.dataset.sharePath, location.origin);
      previewUrl.searchParams.set('preview_theme_id', previewThemeId);
      shareUrl = previewUrl.href;
      const field = root.querySelector('[data-share-field]');
      if (field) field.value = shareUrl;
    }
    root.querySelector('[data-share]')?.addEventListener('click', () => openDialog('share'));
    const nativeShareButton = root.querySelector('[data-native-share]');
    if (nativeShareButton && typeof navigator.share === 'function') {
      nativeShareButton.hidden = false;
      nativeShareButton.addEventListener('click', async () => {
        try { await navigator.share({title: strings.shareTitle, url: shareUrl}); }
        catch (error) {
          if (error.name !== 'AbortError') root.querySelector('[data-copy-status]').textContent = strings.shareUnavailable;
        }
      });
    }
    root.querySelector('[data-copy]')?.addEventListener('click', async () => {
      const field = root.querySelector('[data-share-field]');
      const message = root.querySelector('[data-copy-status]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(shareUrl);
        message.textContent = strings.copied;
      } catch {
        field.focus();
        field.select();
        field.setSelectionRange(0, field.value.length);
        message.textContent = strings.copyManual;
      }
    });
    const photoLinks = Array.from(root.querySelectorAll('[data-gallery-image]'));
    let visiblePhotos = photoLinks.slice();
    let currentPhoto = 0;
    const lightbox = root.querySelector('[data-dialog="lightbox"]');
    const showPhoto = (index) => {
      if (!visiblePhotos.length || !lightbox) return;
      currentPhoto = (index + visiblePhotos.length) % visiblePhotos.length;
      const link = visiblePhotos[currentPhoto];
      const image = lightbox.querySelector('[data-lightbox-image]');
      image.alt = link.dataset.alt || '';
      image.src = link.href;
      lightbox.querySelector('[data-lightbox-caption]').textContent = link.dataset.caption || '';
      lightbox.querySelector('[data-photo-count]').textContent = `${currentPhoto + 1} / ${visiblePhotos.length}`;
      lightbox.querySelectorAll('[data-photo-prev],[data-photo-next]').forEach((button) => { button.disabled = visiblePhotos.length < 2; });
    };
    photoLinks.forEach((link) => link.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      showPhoto(visiblePhotos.indexOf(link));
      openDialog('lightbox');
    }));
    lightbox?.querySelector('[data-photo-prev]')?.addEventListener('click', () => showPhoto(currentPhoto - 1));
    lightbox?.querySelector('[data-photo-next]')?.addEventListener('click', () => showPhoto(currentPhoto + 1));
    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showPhoto(currentPhoto - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showPhoto(currentPhoto + 1); }
    });
    let touchStart = null;
    lightbox?.querySelector('[data-lightbox-image]')?.addEventListener('touchstart', (event) => {
      touchStart = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
    }, {passive: true});
    lightbox?.querySelector('[data-lightbox-image]')?.addEventListener('touchend', (event) => {
      if (!touchStart || event.changedTouches.length !== 1 || event.touches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) showPhoto(currentPhoto + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, {passive: true});
    lightbox?.querySelector('[data-lightbox-image]')?.addEventListener('error', () => {
      lightbox.querySelector('[data-lightbox-caption]').textContent = strings.imageError;
    });
    const applyAlbum = () => {
      if (!photoLinks.length) return;
      let album;
      try { album = decodeURIComponent(location.hash.slice(1)) || 'all'; } catch { album = 'all'; }
      const known = Array.from(root.querySelectorAll('[data-album-filter]')).some((filter) => filter.dataset.albumFilter === album);
      if (!known) album = 'all';
      root.querySelectorAll('[data-album]').forEach((photo) => { photo.hidden = album !== 'all' && photo.dataset.album !== album; });
      root.querySelectorAll('[data-album-filter]').forEach((filter) => filter.setAttribute('aria-current', String(filter.dataset.albumFilter === album)));
      visiblePhotos = photoLinks.filter((link) => !link.closest('[data-album]').hidden);
    };
    applyAlbum();
    window.addEventListener('hashchange', applyAlbum);
    window.addEventListener('storage', (event) => {
      if (event.key === favoriteKey) { favorite = stored(favoriteKey); updateFavorite(); }
      if (event.key === mutedKey) { muted = stored(mutedKey); updateMuted(); }
    });
    const track = (kind, label = '') => {
      if (previewThemeId || window.Shopify?.designMode) return;
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({event:'myggpspace_engagement',myggpspace_action:kind,myggpspace_label:label,myggpspace_view:root.dataset.view});
    };
    track('profile_view');
    root.querySelectorAll('[data-track]').forEach((link) => link.addEventListener('click', () => track(link.dataset.track, link.dataset.trackName || link.textContent.trim().slice(0,120))));
    root.querySelectorAll('[data-album-filter]').forEach((link) => link.addEventListener('click', () => track('album',link.textContent.trim())));
  };
  document.querySelectorAll('[data-myggp]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-myggp]').forEach(initialize));
})();
